










import { Vue, Component } from 'vue-property-decorator';
import ConfigurarPantallaMotivo from './ConfigurarPantallaMotivo.vue';

@Component({
  components: { ConfigurarPantallaMotivo },
})
export default class MotivodeBajaPantalla extends Vue {}
